import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import {
    ColumnConfigItem,
    PersonOfInterest,
} from '../models/coaching.global.model';
import { FLOAMetric } from '../models/floa.model';
import { CoachingInsightWidgetService } from '../services/coaching-insight.widget.service';
import { FrontlineOAService } from '../services/frontline-oa.service';

// maintain a list of Team Member Metrics
@Component({
    selector: '[frontlineMetricRow]',
    templateUrl: './frontline-metric-row.component.html',
})
export class FrontlineMetricRowComponent implements OnInit {
    @Input() selectedUser: PersonOfInterest;
    @Input() active: string[];
    @Input() floaMetric: FLOAMetric;
    @Input() headerColumns: Observable<ColumnConfigItem[]>;

    @HostBinding('class.team-floa-row') true;

    public columns: Observable<ColumnConfigItem[]>;

    i18n = TranslationKeyMap;
    hasPendingData: boolean = false;

    public activetab: string = 'tab-performance';
    public activecolumns: Observable<number>;

    barcolours = {
        numeratorColour: 'green',
        denominatorColour: 'red',
    };

    barWidth: string;

    constructor(
        private readonly _floaService: FrontlineOAService,
        private readonly _coachingInsightService: CoachingInsightWidgetService,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        this.columns = this._floaService.metricscolumns;
        this.columns.pipe(first()).subscribe();

        if (this.floaMetric.topOpps != null) {
            const g =
                (this.floaMetric.opportunityCount / this.floaMetric.topOpps) *
                100;
            this.barWidth =
                typeof g === 'number' && g !== Infinity && g !== -Infinity
                    ? `${g.toString()}%`
                    : '0%';
        } else {
            this.barWidth = '100%';
        }
    }
}
